<section
  class="hd-gate-info-cheat-sheet"
  [class.is-hidden-colors]="effectiveHideColors()"
  [class.is-state-undefined]="!effectiveHideColors() && isUndefinedState()"
  [class.is-state-unactivated]="!effectiveHideColors() && isUnactivatedState()"
  [attr.data-gate]="gateInfo().gate"
  [style.background-color]="effectiveHideColors() ? null : backgroundColor()"
  [style.border-color]="effectiveHideColors() ? null : borderColor()"
  [style.--cheat-sheet-hatch-color]="!effectiveHideColors() && hatchColor() ? hatchColor() : null"
>
  <header class="cheat-sheet-header">
    <div
      class="cheat-sheet-glyph-block"
      [class.is-hidden]="effectiveHideGateNumber()"
    >
      <span class="cheat-sheet-gate-number">{{ gateInfo().gate }}</span>
      <span class="iching-glyph cheat-sheet-iching">{{ gateInfo().metadata.ichingChar }}</span>
    </div>

    <div
      class="cheat-sheet-keynotes"
      [class.is-hidden]="effectiveHideKeynotes()"
    >
      <span class="cheat-sheet-keynote">{{ gateInfo().translations.keynote1 }}</span>
      @if (gateInfo().translations.keynote2) {
        <span class="cheat-sheet-keynote">{{ gateInfo().translations.keynote2 }}</span>
      }
    </div>

    <div class="cheat-sheet-header-right">
      <span
        class="cheat-sheet-center-label"
        [class.is-hidden]="effectiveHideColors()"
      >{{ centerLabel() }}</span>
      @if (iconLayoutViewModel().length > 0) {
        <div
          class="cheat-sheet-icon-stack"
          [class.is-hidden]="effectiveHideColors()"
        >
          @for (row of iconLayoutViewModel(); track $index) {
            <div class="cheat-sheet-icon-row">
              @for (icon of row; track icon.key) {
                <hd-gate-attribute-icon [gate]="gateInfo().gate" [iconKey]="icon.key" [label]="icon.label" />
              }
            </div>
          }
        </div>
      }
    </div>
  </header>

  <div
    class="cheat-sheet-body"
    [class.is-hidden]="effectiveHideBody()"
    [class.is-lines-view]="effectiveBodyView() === 'lines'"
    [class.has-lc]="lineCompanionVisible()"
    [class.has-iching]="classicIChingVisible()"
  >
    @if (lineCompanionVisible()) {
      <!-- Line Companion (community-content): mini-knop vlak voor de lijnen-toggle. -->
      <button
        type="button"
        class="cheat-sheet-lc-toggle"
        [attr.aria-label]="tooltipLineCompanion"
        [title]="tooltipLineCompanion"
        (click)="openLineCompanion($event)"
      >
        <i class="fa-regular fa-book-open-lines" aria-hidden="true"></i>
      </button>
    }
    @if (classicIChingVisible()) {
      <!-- Classic I Ching: mini-knop links van de Line Companion-mini (of van de lijnen-toggle). -->
      <button
        type="button"
        class="cheat-sheet-lc-toggle cheat-sheet-iching-toggle"
        [attr.aria-label]="classicIChingGateTooltip()"
        [title]="classicIChingGateTooltip()"
        (click)="openClassicIChing($event)"
      >
        <i class="fa-regular fa-scroll-old" aria-hidden="true"></i>
      </button>
    }
    <button
      type="button"
      class="cheat-sheet-body-toggle"
      [class.is-active]="effectiveBodyView() === 'lines'"
      [attr.aria-label]="ariaLabelBodyToggle"
      [attr.aria-pressed]="effectiveBodyView() === 'lines'"
      [title]="tooltipBodyToggle"
      (click)="toggleBodyView($event)"
    >
      <i class="fa-solid fa-angles-right" aria-hidden="true"></i>
    </button>

    @if (effectiveBodyView() === 'default') {
      <div
        class="cheat-sheet-body-content cheat-sheet-body-content--default"
        [class.is-animated]="bodyViewAnimated()"
      >
        <p class="cheat-sheet-iching-description">{{ gateInfo().translations.shortIchingDescription }}</p>
        @if (gateInfo().translations.extraNotes.length > 0) {
          <div class="cheat-sheet-extra-notes">
            @for (note of gateInfo().translations.extraNotes; track $index) {
              <p class="cheat-sheet-extra-note">{{ note }}</p>
            }
          </div>
        }
        @if (physicalAndDnaNote()) {
          <!-- De fysiologie-/DNA-noot verraadt het center (bv. "Keel, Schildklier"), dus ze
               valt ook onder de kleuren+center-toggle, niet alleen onder de body-toggle. -->
          <p class="cheat-sheet-physical-note" [class.is-hidden]="effectiveHideColors()">{{ physicalAndDnaNote() }}</p>
        }
      </div>
    } @else {
      <div
        class="cheat-sheet-body-content cheat-sheet-body-content--lines"
        [class.is-animated]="bodyViewAnimated()"
      >
        <ul class="cheat-sheet-lines">
          @for (line of descendingLineKeynotes(); track line.lineNumber) {
            <li
              class="cheat-sheet-line"
              [class.is-activated]="line.activatingPlanets.length > 0"
            >
              <span class="cheat-sheet-line-number">{{ line.lineNumber }}</span>
              <span class="cheat-sheet-line-keynote">
                {{ line.keynote }}
                @if (lineCompanionVisible()) {
                  <!-- Line Companion (community-content): direct naar deze lijn. -->
                  <button
                    type="button"
                    class="cheat-sheet-line-lc"
                    [attr.aria-label]="tooltipLineCompanion + ' ' + context().gate + '.' + line.lineNumber"
                    [title]="tooltipLineCompanion"
                    (click)="openLineCompanionLine(line.lineNumber, $event)"
                  >
                    <i class="fa-regular fa-book-open-lines" aria-hidden="true"></i>
                  </button>
                }
                @if (classicIChingVisible()) {
                  <!-- Classic I Ching: direct naar deze lijn in de klassieke tekst. -->
                  <button
                    type="button"
                    class="cheat-sheet-line-lc cheat-sheet-line-iching"
                    [attr.aria-label]="classicIChingLineTooltip()(line.lineNumber)"
                    [title]="classicIChingLineTooltip()(line.lineNumber)"
                    (click)="openClassicIChingLine(line.lineNumber, $event)"
                  >
                    <i class="fa-regular fa-scroll-old" aria-hidden="true"></i>
                  </button>
                }
              </span>
              @if (line.activatingPlanets.length > 0) {
                <span class="cheat-sheet-line-activations">
                  @for (planet of line.activatingPlanets; track $index) {
                    <span
                      class="cheat-sheet-line-glyph"
                      [class.is-personality]="planet.side === 'personality'"
                      [class.is-design]="planet.side === 'design'"
                    >{{ planet.glyph }}</span>
                  }
                </span>
              }
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <footer class="cheat-sheet-footer">
    @if (footerCircuits().length > 0) {
      <div
        class="cheat-sheet-circuit-block"
        [class.is-hidden]="effectiveHideFooterCircuit()"
      >
        <div
          class="cheat-sheet-circuit-color"
          [class.is-duo]="footerCircuits().length > 1"
          [class.is-hidden]="effectiveHideColors()"
        >
          @for (circuit of footerCircuits(); track trackCircuit($index, circuit)) {
            <span
              class="cheat-sheet-circuit-color-half"
              [style.background-color]="circuit.color"
            ></span>
          }
        </div>
        <span class="cheat-sheet-circuit-name">
          @for (circuit of footerCircuits(); track trackCircuit($index, circuit); let last = $last) {
            <span>{{ circuit.name }}</span>
            @if (!last) {
              <span class="cheat-sheet-circuit-sep"> / </span>
            }
          }
        </span>
        @if (footerCircuits()[0].themeIcon; as themeIcon) {
          <i
            class="fa-regular fa-{{ themeIcon }} cheat-sheet-theme-icon"
            [title]="footerCircuits()[0].themeLabel ?? ''"
            [attr.aria-label]="footerCircuits()[0].themeLabel ?? null"
          ></i>
        }
      </div>
    }
    <span
      class="cheat-sheet-footer-right"
      [class.is-hidden]="effectiveHideFooterChannel()"
    >{{ footerRight() }}</span>
  </footer>
</section>
